// extracted by mini-css-extract-plugin
export default {"li":"Word_li__z6h1A","h1":"Word_h1__QQ+6f","h2":"Word_h2__W67oA","p":"Word_p__MUb2-"};